import React from 'react';
import Footer from '../../shared/Footer';

const LandingPageFooter = ({ onGetStarted }) => {
  return <Footer variant="landing" onGetStarted={onGetStarted} />;
};

export default LandingPageFooter; 